import { HttpBackend, HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { catchError, of } from 'rxjs';
import { AddHeaderVersionInterceptor } from 'src/app/core/interceptors/add-header-version/add-header-version.interceptor';
import { TRANSLATIONS_MAP } from 'src/app/helpers/translations-map';


// TODO: copiar os assets do bucket durante build pra melhorar performance
@Pipe({
  name: 'tr',
  pure: false,
})
export class TranslatePipe implements PipeTransform {
  private static translations: Record<string, any> = TRANSLATIONS_MAP;

  static init = (httpBackend: HttpBackend) => async () => {
    const lang = navigator.language.split('-')[0];
    try {
      const httpClient = new HttpClient({
        handle: (req) => {
          return new AddHeaderVersionInterceptor().intercept(req, httpBackend);
        },
      });
      httpClient
        .get<Record<string, string>>(
          `https://guedder-translations.s3.us-west-2.amazonaws.com/${lang}.json`
        )
        .pipe(
          catchError((error) => {
            return of(TRANSLATIONS_MAP);
          })
        )
        .subscribe((translations) => {
          TranslatePipe.translations = translations;
        });
    } catch (error) {
      console.log('🚀 ~ TranslatePipe ~ init ~ error:', error);
    }
  };

  constructor() {}

  transform(value: string, gender?: string) {
    if (value == null) return '';
    if (typeof value !== 'string') {
      throw 'Tipo de argumento inválido';
    }
    if (TranslatePipe.translations.hasOwnProperty(value)) {
      const valueTranslated =
        TranslatePipe.translations[
          value as keyof typeof TranslatePipe.translations
        ];
      if (gender && valueTranslated.hasOwnProperty(gender)) {
        return valueTranslated[gender as keyof typeof valueTranslated];
      }
      if (gender && valueTranslated.hasOwnProperty('other')) {
        return valueTranslated['other'];
      }
      return valueTranslated;
    }

    return value;
  }
}
